module.exports = __webpack_public_path__ + "img/fond-troupeau6test.567ac276.jpg";